/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2019-06-10 15:30:22
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-27 11:29:06
 */
import Vue from 'vue'
import router from './router'
import store from './store'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'
import { getCookie } from '@/utils/util.js'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['login', 'register', 'registerResult', 'forgotPassword', 'PrintPreview'] // no redirect whitelist

router.beforeEach((to, from, next) => {
    NProgress.start() // start progress bar
    to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} - ${domTitle}`))
    const token = getCookie('token')
    if (token) {
        /* has token */
        if (to.path === '/user/login') {
            next({ path: '/dashboard/workplace' })
            NProgress.done()
        } else {
            if (!store.getters.userInfo.id) {
                store.dispatch('GetInfo')
                    .then(res => {
                        //token创建时间
                        const token_create_time = Vue.ls.get('TOKEN_CREATE_TIME')
                        //过期时间(秒)
                        const token_exp = res.token_exp
                        //过期时间点的时间戳(毫秒)
                        const expire = token_create_time + token_exp * 1000
                        const now = Date.parse(new Date())
                        //保险差值(毫秒)，提前300秒刷新
                        const validDiff = expire - now - 300 * 1000
                        //倒计时时间(毫秒)
                        const count_down = validDiff > 0 ? validDiff : 0
                        //刷新页面时，根据以上参数计算出倒计时的剩余时间进行刷新token
                        setTimeout(() => {
                            store.dispatch('RefreshToken').then((res) => {
                                //正常情况周期刷新时间(毫秒)
                                const cycle = token_exp * 1000 - 300 * 1000
                                const timer = setInterval(() => {
                                    store.dispatch('RefreshToken').then((res) => {

                                    }).catch((err) => {
                                        clearInterval(timer);
                                    });
                                }, cycle)
                            }).catch((err) => {
                                notification.error({
                                    message: '错误',
                                    description: '刷新签名失败'
                                })
                            });
                        }, count_down)
                        //再次请求时以获取到组织id
                        store.dispatch('GetInfo').then((res1) => {
                            const perm_list = res1.perm_list
                            store.dispatch('GenerateRoutes', { perm_list }).then(() => {
                                // 根据perm_list权限生成可访问的路由表
                                // 动态添加可访问路由表
                                router.addRoutes(store.getters.addRouters)

                                const redirect = decodeURIComponent(from.query.redirect || to.path)
                                if (to.path === redirect) {
                                    // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                                    next({ ...to, replace: true })
                                } else {
                                    // 跳转到目的路由
                                    next({ path: redirect })

                                }
                            })
                        })

                    })
                    .catch((err) => {
                        store.dispatch('Logout').then(() => {
                            next({ path: '/user/login', query: { redirect: to.fullPath } })
                        })
                    })
            } else {
                next()
            }
        }
    } else {
        if (whiteList.includes(to.name)) {
            // 在免登录白名单，直接进入
            next()
        } else {
            next({ path: '/user/login', query: { redirect: to.fullPath } })
            NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
        }
    }
})

router.afterEach(() => {
    NProgress.done() // finish progress bar
})

/**
 * Action 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-action:[method] , 如下：
 *    <i-button v-action:add >添加用户</a-button>
 *    <a-button v-action:delete>删除用户</a-button>
 *    <a v-action:edit @click="edit(record)">修改</a>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 *  - 当后台权限跟 pro 提供的模式不同时，只需要针对这里的权限过滤进行修改即可
 *
 *  @see https://github.com/sendya/ant-design-pro-vue/pull/53
 */
const action = Vue.directive('action', {
    bind: function (el, binding, vnode) {
        const actionName = binding.arg
        const perm_list = store.getters.perm_list
        if (perm_list && !perm_list.includes(actionName)) {
            el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
        }
    }
})


// 废弃原因：面包屑右侧的操作按钮应用异常
/**
 * DisabledAction 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-disabled-action:[method] , 如下：
 *    <i-button v-disabled-action:add >添加用户</a-button>
 *    <a-button v-disabled-action:delete>删除用户</a-button>
 *    <a v-disabled-action:edit @click="edit(record)">修改</a>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会变为不可点击
 *  - 当后台权限跟 pro 提供的模式不同时，只需要针对这里的权限过滤进行修改即可
 *
 *  @see https://github.com/sendya/ant-design-pro-vue/pull/53
 */
// const disabled_action = Vue.directive('disabled-action', {
//     bind: function (el, binding, vnode) {
//         debugger
//         const actionName = binding.arg
//         const perm_list = store.getters.perm_list
//         if (perm_list.actionList&&!perm_list.actionList.includes(actionName)){
//             el.parentNode && el.parentNode.removeChild(el) || (el.setAttribute('disabled', true))
//         }
//     }
// })

export {
    action,
    // disabled_action
}


// WEBPACK FOOTER //
// ./src/permission.js